import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root'
})
export class InventoryhistoryService {

  public mtds: Methods = new Methods();
  public url: string;
  public token;
  public headers;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/inventory_history/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }
  showallopti(page = 1, perPage = 10, search = '', sort = '', sortby = '', filtros = [],    task:any,
  order:any): Observable<any> {
    let json = {search , sort : [task],order };

    let url = this.url + 'listopti?page=' + page + '&perpage=' + perPage;

    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = url + '&order=' + sort + '&orderby=' + filtros[sortby].key;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + '&' + filtro.key + '=' + filtro.value;

        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }

    return this.petition2(url, json);
  }
  
  showAll(page = 1, perPage = 10, search = '', sort = '', sortby = '', filtros = []): Observable<any> {
    let json = {
      search
    };

    let url = this.url + 'listall?page=' + page + '&perpage=' + perPage;

    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = url + '&order=' + sort + '&orderby=' + filtros[sortby].key;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = url + '&' + filtro.key + '=' + filtro.value;

        if (filtro.type) {
          url = url + '&' + filtro.key_type + '=' + filtro.type;
        }
      }
    }

    return this.petition(url, json);
  }

  petition(url, json = null, type = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams()
      .set('authorization', this.token);

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    return this._http.post(
      url,
      params.toString(),
      { headers: this.headers }
    );
  }
  petition2(url, json = null, type = null): Observable<any> {

    this.token = JSON.parse(localStorage.getItem('token'));
    let params = new HttpParams().set('authorization', this.token);

    if (json != null) {
      //json = encodeURIComponent(JSON.stringify(json));
      json = JSON.stringify(json);
      params = params.set('json', json);
    }

    if (type != null) {
      params = params.set('type', type);
    }

    return this._http.post(
      url,
      params,
      {headers: this.headers}
    );
  }
}
